import { render } from "./EditorBoxUpperText.vue?vue&type=template&id=633a9f4c&scoped=true"
import script from "./EditorBoxUpperText.vue?vue&type=script&lang=js"
export * from "./EditorBoxUpperText.vue?vue&type=script&lang=js"

import "./EditorBoxUpperText.vue?vue&type=style&index=0&id=633a9f4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-633a9f4c"

export default script